import { Box, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { MessageQuestionCustomLinearIcon } from '../../../../../../../icons-lib';
import i18n from '../../../../../../../i18';

export const TextCampField = ({
    field,
    data,
    // additionalData,
    onChange
}) => {
    const { id, label, tipText } = field;
    const placeholderLabel = i18n.t(`placeholder.${label}`);
    const translatedLabel = i18n.t(`columns.${label}`);
    return (
        <Box sx={{ mb: 2 }}>
            <Box display={'flex'} alignItems={'center'}>
                <Typography variant="body2">{translatedLabel}</Typography>
                {tipText && (
                    <Tooltip title={tipText} placement="top">
                        <IconButton size="small">
                            <MessageQuestionCustomLinearIcon
                                sx={{ fontSize: '1rem' }}
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            <TextField
                fullWidth
                variant="outlined"
                placeholder={placeholderLabel}
                sx={{
                    '& .MuiInputBase-input': {
                        fontSize: 16,
                        height: 32,
                        padding: 1
                    }
                }}
                value={data || ''}
                onChange={(event) => onChange(id, event.target.value)}
            />
        </Box>
    );
};
